import angular from 'angular';
import ImageUtilsServiceFactory from './image.factory';
import LoginServiceFactory from './login.factory';
import LoaderServiceFactory from './loader.factory';
import BeaconServiceFactory from './beacon.factory';
import PosServiceFactory from './pos.factory';
import ClosingsFactory from './closings.factory';
import InvoicesServiceFactory from './invoices.factory';
import MerchantConfigurationFactory from './merchantConfiguration.factory';
import MovementsFactory from './movements.factory';
import TermsServiceFactory from './terms.factory';
import DocumentsServiceFactory from './documents.factory';
import StentleBackendServiceFactory from './stentle.factory';
import CatalogServiceFactory from './catalog.factory';
import SuperAdminFactory from './superAdmin.factory';
import MessageOutboundFactory from './messageOutbound.factory';
import MerchantServicesFactory from './merchant.services.factory';
import MerchantVasFactory from './merchant.vas.factory';
import CategoriesFactory from './categories.factory';
import TokenServiceFactory from './tinaba-framework/token.factory';
import BackendServiceFactory from './tinaba-framework/backend.factory';
import MerchantProfileFactory from './tinaba-framework/merchantProfile.factory';
import UiServiceFactory from './tinaba-framework/ui.factory';
import UserInstrumentActionsFactory from './tinaba-framework/userInstrumentAction.factory';
import UserInstrumentStoreFactory from './tinaba-framework/userInstrumentStore.factory';
import DashboardActionsFactory from './tinaba-framework/dashboardActions.factory';
import InstrumentHistoryFactory from './tinaba-framework/instrumentHistory.factory';
import DashboardStoreFactory from './tinaba-framework/dashboardStore.factory';
import ValidazioneServiceFactory from './tinaba-framework/validazione.factory';
import StorageServiceFactory from './tinaba-framework/storage.factory';
import DispatcherServiceFactory from './tinaba-framework/dispatcher.factory';
import JsonLoaderServiceProvider from './tinaba-framework/jsonLoader.factory';
import MerchantProfileStoreFactory from './tinaba-framework/merchantProfileStore.factory';
import UserContextHelperServiceFactory from './tinaba-framework/userContextService.factory';
import MerchantDetailServiceFactory from './tinaba-framework/merchantDetail.factory';
import UserHelperServiceFactory from './tinaba-framework/userHelper.factory';
import MerchantDetailActionsFactory from './tinaba-framework/merchantDetailActions.factory';
import MerchantDetailStoreFactory from './tinaba-framework/merchantDetailStore.factory';
import DocServiceFactory from './tinaba-framework/doc.factory';
import merchantDeviceFactory from './tinaba-framework/merchantDevice.factory';
import StoreServiceFactory from './store.factory';
import ScaServiceFactory from './sca.factory';
import PickupPointFactory from './pickupPoint.factory';
import PollingServiceFactory from './tinaba-framework/polling.factory';

const servicesModule = angular.module('tinaba.services', [])


  .factory('ImageUtilsService', ImageUtilsServiceFactory)

  .factory('LoginService', LoginServiceFactory)

  .factory('LoaderService', LoaderServiceFactory)

  .factory('BeaconService', BeaconServiceFactory)

  .factory('PosService', PosServiceFactory)

  .factory('ClosingsService', ClosingsFactory)

  .factory('InvoicesService', InvoicesServiceFactory)

  .factory('MerchantConfigurationService', MerchantConfigurationFactory)

  .factory('MovementsService', MovementsFactory)

  .factory('TermsService', TermsServiceFactory)

  .factory('DocumentsService', DocumentsServiceFactory)

  .factory('StentleBackendService', StentleBackendServiceFactory)

  .factory('CatalogService', CatalogServiceFactory)

  .factory('SuperAdminService', SuperAdminFactory)

  .factory('MerchantVasService', MerchantVasFactory).constant('VasTypes', {
    CHECKIN: 0,
    ORDER_AND_PAY: 1,
    PROMO_OUTBOUND: 2,
    DELIVERY: 3,
    TABLE: 4,
    PICK: 5,
    INVOICES: 6,
    CORPORATE_CASH: 7,
    OFFICE_DELIVERY: 8,
    PAY_WITH_ALIPAY: 50,
    PROJECT_WITH_ALIPAY: 51,
    MOBILE_PAY_WITH_ALIPAY: 52,
    ONLINE_PAY_WITH_CONNECT: 63  
  })

  .factory('MessageOutboundService', MessageOutboundFactory)

  .factory('MerchantService', MerchantServicesFactory)

  .factory('CategoriesService', CategoriesFactory)

  .factory('NewTokenService', TokenServiceFactory).constant('MerchantTypes', {
    'EASY': 0,
    'BUSINESS': 1,
    'DOUBLE': 2
  })
  .constant('LoginErrors', {
    'WRONGCREDENTIALS': "Wrong credentials",
    'TEMPORARYLOCK': "This account is temporary blocked",
    'PERMANENTLOCK': "This account is permanently blocked",
    'DISABLED': "This account is not enabled",
    'INVALIDGRANT': 'invalid_grant',
    'SIGNING_UP': 'User not enabled. Forced to logout', // Custom per utenti non ancora abilitati
    'PIN_LOCKED': 'User PIN locked. Forced to logout' // Custom per utenti con pin bloccato
  })
  .constant('LoggedUserStates', {
    'ENABLED': 'ENABLED',
    'ENABLED_UPGRADING1B': 'UPGRADING_L1B',
    'ENABLED_UPGRADING2': 'UPGRADING_L2',
    'UNCONFIRMED1A': 'SIGNING_UP_L1A',
    'UNCONFIRMED1B': 'SIGNING_UP_L1B',
    'CHANGING_PASSWORD': 'CHANGING_PASSWORD'
  })

  .factory('NewMerchantProfileService', MerchantProfileFactory)

  .factory('NewBackendService', BackendServiceFactory)

  .factory('NewUserInstrumentActions', UserInstrumentActionsFactory)

  .factory('NewDashboardActions', DashboardActionsFactory)

  .factory('NewInstrumentHistoryService', InstrumentHistoryFactory)

  .factory('NewDashboardStore', DashboardStoreFactory)

  .factory('ValidazioneService', ValidazioneServiceFactory)
  
  .factory('StorageService', StorageServiceFactory)

  .factory('Dispatcher', DispatcherServiceFactory)

  .factory('JsonLoaderService', JsonLoaderServiceProvider)

  .factory('MerchantProfileStore', MerchantProfileStoreFactory).run(['MerchantProfileStore', function(MerchantProfileStore) { // eslint-disable-line no-unused-vars
    //just to eager load service
  }])

  .factory('UserContextHelperService', UserContextHelperServiceFactory)

  .factory('MerchantDetailService', MerchantDetailServiceFactory)

  .factory('UserHelperService', UserHelperServiceFactory)

  .factory('MerchantDetailActions', MerchantDetailActionsFactory)

  .factory('MerchantDetailStore', MerchantDetailStoreFactory)

  .factory('docService', DocServiceFactory)

  .factory('MerchantDeviceService', merchantDeviceFactory)

  .factory('PickupPointService', PickupPointFactory)

  .factory('NewUserInstrumentStore', UserInstrumentStoreFactory).run(['NewUserInstrumentStore', function(NewUserInstrumentStore) { 
    //just to eager load service
  }])

  .factory('NewUiService', UiServiceFactory).constant('SocialProvisionsDaysFilter', {
    'OPTIONS': [5, 15, 30, 60, 90],
    'DEFAULT': 30
  })

  .constant('StoreStates', {
    "STORE_EMPTY": "STORE_EMPTY",
    "STORE_PENDING_UPDATE": "STORE_PENDING_UPDATE",
    "STORE_FAILED_UPDATE": "STORE_FAILED_UPDATE",
    "STORE_VALID": "STORE_VALID",
    "STORE_EXPIRED": "STORE_EXPIRED"
  })

  .factory('StoreService', StoreServiceFactory)

  .factory('ScaService', ScaServiceFactory)
  .constant('scaTypeConstants', 
  {
    MOVEMENTS: 'MOVEMENTS',
    DOCUMENTS: 'DOCUMENTS',
    LOGIN: "LOGIN"
  })

  .factory('PollingService', PollingServiceFactory)
  

export default servicesModule;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/services.js
 **/